/**
 * Creates a reactive state for a Google Analytics entity.
 *
 * @template T The type of the entity state
 * @param {string} entityName - A unique name for the entity state
 * @returns {Ref<T | undefined>} A reactive reference to the entity state
 * @example
 * // Create a reactive state for a cart payload
 * const cartPayload = useGAEntity<CartPayload>('CART_PAYLOAD')
 */
export const useGAEntity = <T>(entityName: string) =>
  useState<T>(entityName, undefined)
